import React from "react";
import Footer from "../footer";
import Avbar from "../navbar/Navbar";
import  emailjs  from "@emailjs/browser";
import useVH from 'react-viewport-height';

const ContactForm = () => {
  useVH();

  const onSubmit = (e) => {
    e.preventDefault();
    const { name, email, message } = e.target.elements;
    const service_ID  = "service_ak4t5n9";
    const template_id = "template_3xnliyl";
    const PublicKey = "wO3TmDNAfwDV2zL-d"
    const Perams = {
    
      to_name : 'avitdesai6145@gmail.com',
      from_name : name.value,
      from_email : email.value,
      message : message.value
  
  
  }
  emailjs.send(service_ID,template_id,Perams,PublicKey)
  .then((res) => {
    alert(`Hi ${name.value}! Thanks for contacting me. You will receive an email within 24 Hours.Make sure you entered the right email.`)
  }).catch((err) => {
    alert(err)
  })
  
    
  };

  return (
    <>
      <Avbar />

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          padding: "10% 0px 10% 0px",
          minHeight : `calc(var(--vh, 1vh) * 86)`
        }}
      >

        <form onSubmit={onSubmit} style={{ width: "50%", margin: "auto" }}>
        <h2 style={{ fontSize: "36px", fontWeight: "bold" }}>Contact Me</h2>

          <div className="mb-3">
            <label
              style={{ display: "block", marginBottom: "5px" }}
              htmlFor="name"
              
            >
              Name:
            </label>
            <input
              style={{ width: "100%", padding: "10px", border: "1px solid #ccc" }}
              type="text"
              id="name"
              required
            />
          </div>

          <div className="mb-3">
            <label
              style={{ display: "block", marginBottom: "5px" }}
              htmlFor="email"
            >
              Email:
            </label>
            <input
              style={{ width: "100%", padding: "10px", border: "1px solid #ccc" }}
              type="email"
              id="email"
              required
            />
          </div>

          <div className="mb-3">
            <label
              style={{ display: "block", marginBottom: "5px" }}
              htmlFor="message"
            >
              Message:
            </label>
            <textarea
              style={{ width: "100%", height: "100px", padding: "10px", border: "1px solid #ccc" }}
              id="message"
              required
            />
          </div>

          <button
            className="btn"
            type="submit"
            style={{
              
              color: "#fff",
              padding: "auto",
              width: "100%",
              margin: "auto",
              
              border: "none",
              borderRadius: "5px",
            }}
          >
            Submit
          </button>
        </form>
      </div>

      <Footer />
    </>
  );
};

export default ContactForm;
